import React, { useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { Link } from "react-router-dom";
// import { baseApiUrl } from "../../services/api";

import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Importation corrigée
import { ca } from "date-fns/locale";
import { baseApiUrl } from "../../../services/api";

const Publication = () => {


  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [document, setDocument] = useState(null);
  const [image, setImage] = useState("");
  const [zoneExecution, setZoneExecution] = useState(null);
  const [impactEconomique, setImpactEconomique] = useState(null);
  const [impactSocial, setImpactSocial] = useState(null);
  const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);
  const [video, setVideo] = useState("");
  const [step, setStep] = useState(1);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [projetToDelete, setProjetToDelete] = useState(null);
  const showDeleteModal = (id) => {
    setProjetToDelete(id);
    setIsDeleteModalVisible(true);
  };


  const [projets, setProjets] = useState([]);
  const [publications, setPublications] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);

  const [selectedCategorie, setSelectedCategorie] = useState(null);


  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleCancelDelete = () => {
    setIsDeleteModalVisible(false);
    setProjetToDelete(null);
  };
  const confirmDelete = async () => {
    if (projetToDelete) {
      await handleDelete(projetToDelete);
      setIsDeleteModalVisible(false);
    }


  };

  const handleDeleteConfirm = (projet) => {
    setDeleteProjet(projet);
    setDeleteModalVisible(true);
  };

   
    // const fetchPublications = async () => {
    //   try {
    //     const response = await baseApiUrl.get("/publication/liste");
    //     console.log("Données reçues des publication:", response.data);
  
    //     // Vérifie que les données sont bien un tableau avant de les stocker
    //     setPublications(Array.isArray(response.data) ? response.data : []);
    //   } catch (error) {
    //     console.error("Erreur lors de la récupération des publication de l'utilisateur:", error);
    //   }
    // };

    const fetchPublications = async () => {
      try {
        const response = await baseApiUrl.get("/publication/liste");
        console.log("Données reçues des publications :", response.data);
    
        // Vérifie que les données sont un tableau
        const allPublications = Array.isArray(response.data) ? response.data : [];
    
        // Filtre uniquement les publications de l'utilisateur connecté
        const userPublications = allPublications.filter(pub => pub.utilisateurId === userId);

        
    
        setPublications(userPublications);
        console.log("Publications de l'utilisateur connecté :", userPublications);
      } catch (error) {
        console.error("Erreur lors de la récupération des publications de l'utilisateur :", error);
      }
    };
    
  
  
    const fetchCategories = async () => {
      try {
        const response = await baseApiUrl.get(
          "/categorie/liste"
        );

        console.log("donnnnnnnn:",response)
  
        // Transformer les données pour correspondre au format des options de <Select>
        const options = response.data.map((category) => ({
          value: category.id, // Utiliser l'identifiant ou un autre attribut unique de la catégorie
          label: category.nom, // Utiliser le nom ou un autre attribut descriptif de la catégorie
        }));
  
        setCategoriesOptions(options);
      } catch (error) {
        console.error("Erreur lors de la récupération des catégories:", error);
      }
    };
  
    useEffect(() => {
      fetchCategories();
      fetchPublications();
    }, []);


  
  // useEffect(() => {
  //   const token = localStorage.getItem("token"); // Assurez-vous que c'est le bon nom de clé
  //   if (token) {
  //     try {
  //       const decoded = jwtDecode(token); // Utilisation de jwtDecode
  //       setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
  //       console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
  //     } catch (error) {
  //       console.error("Erreur lors du décodage du token:", error);
  //     }
  //   } else {
  //     console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
  //   }
    
  // }, []);

  const handleAddProjet = async (e) => {
     e.preventDefault();
   
     if (!titre) {
       openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
       return;
     }
   
     try {
       const formData = new FormData();
   
       const projetData = {
         titre,
         description,
         // description2,
         // description3,
         categorieId: selectedCategorie,
         zoneExecution,
         impactEconomique,
         impactEnvironnemental,
         impactSocial,
 
 
       };
   
       formData.append("publication", new Blob([JSON.stringify(projetData)], { 
         type: "application/json"
       }));
   
       if (document) {
         formData.append("document", document);
       }
       if (image) {
         formData.append("image", image);
       }
       if (video) {
         formData.append("video", video);
       }
 
       console.log("Données du publication:", projetData);
 
       console.log("Données du date:", formData);
 
   
       // ✅ Correction de l'appel API avec Axios
       const response = await baseApiUrl.post("/publication/create", formData);
   
       // ✅ Récupération correcte des données
       const newProjet = response.data;
 
       console.log("Réponse API:", newProjet);
       
       setProjets([newProjet, ...projets]);
   
       console.log("Réponse API:", newProjet);
   
       // ✅ Notification de succès
       openNotificationWithIcon("success", "Publication ajouté avec succès.");
       fetchPublications();
     } catch (error) {
       openNotificationWithIcon("error", "Erreur lors de l'ajout du pubblication.");
       console.error("Erreur détectée:", error.response?.data || error.message || error);
     }
   
     resetForm();
   };

 
 

  const resetForm = () => {
    setStep(1);
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    setTitre("");
    setDescription("");
    setSelectedCategorie("");
    setImage("");
    setDocument("");
    
    setZoneExecution("");
    setImpactEconomique("");
    setImpactEnvironnemental("");
    setImpactSocial("")

    
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };



  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };



  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
            
              <div className="col-sm-5 col">
                <Button
                  type="primary"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2"
                >
                  Ajouter une publication
                </Button>
              </div>
            </div>
          </div>

        

          {/* Modal d'ajout de projet */}
          <Modal
            title="Ajouter une publication"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={900}
          >
            <form onSubmit={handleAddProjet}>
              {step === 1 && (
                <>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Titre de la publication</label>
                        <input
                          type="text"
                          className="form-control"
                          value={titre}
                          onChange={(e) => setTitre(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Zone d'exécution</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={zoneExecution}
                          onChange={(e) => setZoneExecution(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact économique</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEconomique}
                          onChange={(e) => setImpactEconomique(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Description de la publication</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={description}
                          onChange={(e) =>
                            setDescription(e.target.value)
                          }
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact environnemental</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactEnvironnemental}
                          onChange={(e) => setImpactEnvironnemental(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Impact Social</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={impactSocial}
                          onChange={(e) => setImpactSocial(e.target.value)}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNext}
                  >
                    Suivant
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                 

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Domaine de la publication</label>
                        <select
                          className="form-control"
                          value={selectedCategorie}
                          onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
                          <option value="">Sélectionnez un domaine...</option>
                          {/* Valeur par défaut */}
                          {categoriesOptions.map((category) => (
                            <option key={category.value} value={category.value}>
                              {category.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Document du publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setDocument(e.target.files[0])}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Image de la publication</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>

                 

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handlePrevious}
                  >
                    Précédent
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"
                   
                  >
                    Créer
                  </button>
                </>
              )}
            </form>
          </Modal>

         
        </div>
      </div>
    </>
  );
};

export default Publication;
